/* Modulo: Hero Spotlight — section behaviour.
   Vanilla IIFE, no deps. Handles:
     - Video pause + autoplay/loop removal under prefers-reduced-motion: reduce
     - Dedup via __moduloHsInit flag
     - Handles 0+ hero-spotlight sections per page
   Hover ken-burns, chip pulse, CTA shimmer, and CTA hover-lift are
   CSS-driven (data-ken-burns / data-chip-pulse / data-cta-shimmer
   attributes gate them in CSS); this file only handles behaviour
   that CSS can't express (video autoplay policy). */
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function handleReducedMotionVideo(section) {
    if (!REDUCE) return;
    var videos = section.querySelectorAll('[data-modulo-hs-video]');
    for (var i = 0; i < videos.length; i++) {
      var v = videos[i];
      try { v.pause(); } catch (_) {}
      v.removeAttribute('autoplay');
      v.removeAttribute('loop');
    }
  }

  function initSection(section) {
    if (section.__moduloHsInit) return;
    section.__moduloHsInit = true;
    handleReducedMotionVideo(section);
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-hs]', initSection);
    } else {
      var els = document.querySelectorAll('[data-modulo-hs]');
      for (var i = 0; i < els.length; i++) initSection(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
